import { registerPlugin, Capacitor } from '@capacitor/core';

const BarcodeScanFrame = registerPlugin('BarcodeScanFrame');

/**
 * ネイティブカメラからグレースケールフレームを取得する（Android / iOS 共通）。
 *
 * @param {{ width?: number, height?: number }} options
 * @returns {Promise<{
 *   data: string,
 *   width: number,
 *   height: number,
 *   captureMs?: number,
 *   processMs?: number,
 *   encodeMs?: number,
 * }>}
 */
export async function captureGrayscaleSample({ width = 1920, height = 1080 } = {}) {
  return BarcodeScanFrame.captureGrayscaleSample({ width, height });
}

/**
 * Android限定で、撮影からバーコードのデコードまでを一括で行う。
 *
 * @param {{ width?: number, height?: number }} options
 * @returns {Promise<{
 *   found: boolean,
 *   codemark: string|null,
 *   codedata: string|null,
 *   width: number,
 *   height: number,
 *   captureMs?: number,
 *   processMs?: number,
 *   decodeMs?: number,
 * }>}
 */
export async function captureAndDecode({ width = 1920, height = 1080 } = {}) {
  return BarcodeScanFrame.captureAndDecode({ width, height });
}

/**
 * Android限定で、ネイティブのバーコード読み取りエンジンにライセンスを設定する。
 *
 * @param {string} licenseBody ライセンス発行APIから取得した本文
 * @returns {Promise<{ ret: number, success: boolean, expirationStatus: number }>}
 */
export async function setNativeLicense(licenseBody) {
  return BarcodeScanFrame.setLicense({ licenseBody });
}

export function isGrayscaleCaptureAvailable() {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }
  return typeof BarcodeScanFrame.captureGrayscaleSample === 'function';
}

// 現時点ではAndroidのみ実装しており、ネイティブ側で撮影からデコードまで一括処理できるかどうかを返す
export function isNativeDecodeAvailable() {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }
  return Capacitor.getPlatform() === 'android'
    && typeof BarcodeScanFrame.captureAndDecode === 'function';
}
